import { useGetFrontTipiDomandaId } from '@framework/api-client';
import { selectTranslatedInquiryType } from '@framework/common-web';
import { useTranslation } from '@framework/i18n';
import { useMemo } from 'react';
import { useControlledAccessSubmission } from './useControlledAccessSubmission';

/**
 * Hook che raccoglie tutti i dati necessari per la visualizzazione di una submission
 */
export function useSubmission(submissionId: string | null) {
  const submissionRequest = useControlledAccessSubmission(submissionId);
  const { t } = useTranslation();

  const submission = useMemo(
    () => submissionRequest.data,
    [submissionRequest.data],
  );

  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const inquiryRequest = useGetFrontTipiDomandaId(submission?.idTipoDomanda!, {
    query: {
      keepPreviousData: true,
      enabled: Boolean(submission?.idTipoDomanda),
      select: selectTranslatedInquiryType,
    },
  });

  const inquiry = useMemo(() => inquiryRequest.data, [inquiryRequest.data]);

  const title = useMemo(
    () =>
      inquiry?.copertina?.titolo ??
      inquiry?.titolo ??
      t('submission.richiesta', 'Richiesta'),
    [inquiry?.copertina?.titolo, inquiry?.titolo, t],
  );

  return {
    submission,
    inquiry,
    title,
    submissionRequest,
    inquiryRequest,
    isLoading: submissionRequest.isLoading || inquiryRequest.isLoading,
  };
}

export type IUseSubmission = ReturnType<typeof useSubmission>;
